<template>
  <div>
    <v-file-input
      v-show="false"
      ref="upload_file"
      @change="uploadFile(file)"
      v-model="file"
    ></v-file-input>

    <v-text-field
      dense
      outlined
      :loading="loading"
      :label="label"
      v-model="path"
      :error-messages="errors.file || errors.path"
    >
      <template v-slot:prepend>
        <v-btn
          title="رفع ملف"
          text
          small
          icon
          color="info"
          @click="$refs[`upload_file`].$refs.input.click()"
        >
          <v-icon>mdi-upload</v-icon>
        </v-btn>
      </template>
    </v-text-field>
  </div>
</template>


<script>
/**
 * this is only for pdf files for now
 */
export default {
  name: 'file-uploader-input',
  props: ['label'],

  data: function () {
    return {
      file: null,
      loading: false,
      path: null,
      errors: {}
    };
  },


  watch: {
    path(value) { this.$emit('input', value); }
  },


  methods: {
    uploadFile(file) {
      this.loading = true;

      // build the form payload
      let payload = new FormData();
      payload.append("type", 'pdf');
      payload.append("file", file);

      // upload the attachment to the server
      return this.axios
        .post("/admin/attachments/upload", payload)
        .then((response) => {
          this.path = response.data.attachment.path.view;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }

          this.$bus.$emit("showSnackbar", {
            text: `تعذر رفع ملف الpdf`,
            color: "accent",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>